import React from 'react';
import { connect } from 'react-redux';
import { toggleBar } from '../../actions/ui_actions';

import magnifyingGlass from '../../assets/magnifying_glass.svg'


const SearchToggle = ({ handleToggleBar, barOpen }) => {
  return (
    <button aria-expanded={barOpen} className="search-toggle-btn" onClick={handleToggleBar} aria-label="Toggle search" title="Toggle search" type="button">
      {barOpen ? 
        (<div role="presentation" className="close-btn" />) : 
        (<figure role="none">
          <img alt="Magnifying Glass" src={magnifyingGlass} />
        </figure>)
      }
      
    </button>)
    
};

const mapStateToProps = state => ({
  barOpen: state.ui.search.barOpen,
});

const mapDispatchToProps = dispatch => ({
  handleToggleBar: () => dispatch(toggleBar()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchToggle);
